import axios from 'axios';

/* # =================================================================
# WP・Laravel共通のリクエスト
# ================================================================= */
export async function getCountTotalUnreadNotification(volunteer_id, year) {
	try {
		const response = await axios.post(Global.laravelUrl + '/api/get_count_total_unread_notification', {
			volunteer_id: volunteer_id,
			year: year,
		});
		return response.data;
	} catch (error) {
		console.error('エラーが発生しました。Error getCountTotalUnreadNotification:', error.message);
		throw new Error('Failed getCountTotalUnreadNotification');
	}
}
